<div class="modal-header">
	<button class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">
	{{#if id}}
	{{TR "Zugriffsrechte ändern"}} - {{name}}
	{{else}}
	{{TR "Nutzer hinzufügen"}}
	{{/if}}
	</h4>
</div>
<div class="modal-body">
	{{#unless id}}
	<div class="row">
		<div class="col-md-12">
			<div id="js-email-region"></div>
		</div>
	</div>
	{{/unless}}
	{{{PERMISSIONS_CONTROL permissionsData}}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-save" {{#unless hasAnyPermission}}disabled{{/unless}}>{{TR "Speichern"}}</button>
</div>
